export default {
  detail: '/api/web/v3/order/detail', // 订单详情
  charge: '/api/web/v3/order/charge', // 获取支付凭证
  orderCreate: '/api/web/v3/order/create', // 创建订单
  lists: '/api/web/v3/order/lists', // 订单列表
  delete: '/api/web/v3/order/delete', // 删除订单
  revoke: '/api/web/v3/order/revoke', // 取消订单
  retrieve: '/api/web/v3/order/retrieve' // 查询订单状态
}
